import axios, { ErrorMessage2 } from '../../../api';
import { endpoints } from '../../../config';
import { RegisterCandidatePayload } from './models';

export type ApiReturn2<T = any> = {
  response: T | null;
  errors: ErrorMessage2[] | null;
  id?: number;
};

const registerCandidateUrl = endpoints.candidateSignUp.registerCandidate;

export const registerCandidateApi = async (
  payload: RegisterCandidatePayload,
  apiErrorMessage: string
): Promise<ApiReturn2> => {
  try {
    const res = await axios.post(registerCandidateUrl, payload);
    if (res.data.status === '1') {
      return {
        response: res.data.id,
        errors: null,
      };
    } else {
      return {
        response: res.data.id,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    return {
      response: null,
      errors: [
        {
          errorType: 'BadRequest',
          fieldName: 'Generic',
          messageCode: apiErrorMessage
        },
      ],
    };
  }
};
